import React from 'react';
import { FileVideo } from 'lucide-react';

export default function ContentTypeSelector({ youtubeContents = [], currentContent, onSelect }) {
	if (!youtubeContents || youtubeContents.length === 0) return null;

	return (
		<div className="flex flex-wrap space-x-2 mb-4">
			<div className="text-sm text-gray-600 mb-2 w-full">Select Content:</div>
			{youtubeContents.map((content, index) => (
				<button
					key={content.id}
					onClick={() => onSelect?.(content)}
					className={`px-3 py-1.5 text-sm rounded flex items-center mb-2 ${
						currentContent?.id === content.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
					}`}
				>
					<FileVideo size={16} className="mr-1" />
					{content.title || `Content ${index + 1}`}
				</button>
			))}
		</div>
	);
}
